<template>
	<div>
		<el-col :span="24" class="toolbar uptool noheight" style="padding-bottom: 0px;" @click="DownForSearch">
			<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">姓名:</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustName" clearable placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">电话:</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustPhone" clearable placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">地址:</el-button>
				</el-form-item>
				<el-form-item>
					<el-cascader size="mini" expand-trigger="hover" :options="Addoptions" v-model="AddrSelect" @change="SelectChange"></el-cascader>
  				</el-form-item>
				<!--<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>-->
			</el-form>
			<el-form :inline="true">
				<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">出生日期:</el-button>
				<el-date-picker size="mini" unlink-panels v-model="BirthTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日 " value-format="timestamp"></el-date-picker>
				<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">受伤日期:</el-button>
				<el-date-picker size="mini" unlink-panels v-model="HurtTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
			</el-form>
			<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">身高(cm):</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustHeight1" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustHeight2" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">体重(kg):</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustWeight1" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustWeight2" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">腰围cm:</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustWaitLine1" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="CustWaitLine2" placeholder="请输入内容" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="mini" @click="Find">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="info" size="mini" @click="rest">重置</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<el-col :span="24" style="padding-bottom: 10px;text-align: center;color: #999;">
			<span>>> </span><span class="downsearch" @click="DownForSearch">点击下拉</span><span> <<</span>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%;" :max-height="maxHeight" id="OnlyBox" @filter-change="Filterfind" @row-dblclick="ChangeIt">
			<el-table-column fixed label="序号" width="50" prop="sNumber"></el-table-column>
			<el-table-column label="姓名" prop="name" fixed></el-table-column>
			<el-table-column label="录入时间" fixed prop="created_at" width='100' :formatter="dateFormat2" ></el-table-column>
		    <el-table-column label="性别" prop="gender" width='65' column-key="gender" :filters="Agender">
		    	<template slot-scope="scope">
					<span v-if="scope.row.gender == 1">男</span>
					<span v-if="scope.row.gender == 2">女</span>
				</template>
		    </el-table-column>
		    <el-table-column label="出生年月" prop="birth"  width='78' :formatter="dateFormat3"></el-table-column>
		    <el-table-column label="身高(cm)" prop="height" width='55'></el-table-column>
		    <el-table-column label="体重(kg)" prop="weight" width='55'></el-table-column>
		    <el-table-column label="腰围(cm)" prop="waist" width='55'></el-table-column>
		    <el-table-column label="学历" prop="edu" width='65' column-key="edu" :filters="Aedu" ></el-table-column>
		    <el-table-column label="职业" prop="job" width='70' column-key="job" :filters="Ajob">
		    	<template slot-scope="scope">
					<span v-if="scope.row.gender == 1">无</span>
					<span v-if="scope.row.gender == 2">学生</span>
					<span v-if="scope.row.gender == 3">文化/艺术</span>
					<span v-if="scope.row.gender == 4">影视/娱乐</span>
					<span v-if="scope.row.gender == 5">金融</span>
					<span v-if="scope.row.gender == 6">医药/健康</span>
					<span v-if="scope.row.gender == 7">工业/制造业</span>
					<span v-if="scope.row.gender == 8">建筑</span>
					<span v-if="scope.row.gender == 9">司机</span>
					<span v-if="scope.row.gender == 10">公职</span>
					<span v-if="scope.row.gender == 11">IT/互联网/通信</span>
					<span v-if="scope.row.gender == 12">媒体/公关</span>
					<span v-if="scope.row.gender == 13">零售</span>
					<span v-if="scope.row.gender == 14">教育/科研</span>
				</template>
		    </el-table-column>
		    <el-table-column label="受伤时间" prop="injurytime" width='78' :formatter="dateFormat3"></el-table-column>
		    <el-table-column label="电话" prop="phone" width='120'></el-table-column>
		    <el-table-column label="常住地" prop="addr" width='150'></el-table-column>
		    <el-table-column label="脊柱损伤">
				<el-table-column label="颈椎段" width='100' prop="AQ1" column-key="AQ11" :filters="AQ11Filt">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.AQ101">
								<span v-if="item == 17">C2~C3</span>
								<span v-if="item == 18">C3~C4</span>
								<span v-if="item == 19">C4~C5</span>
								<span v-if="item == 20">C5~C6</span>
								<span v-if="item == 21">C6~C7</span>
								<span v-if="item == 22">C7~C8</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
				           	<span v-if="scope.row.AQ101[0] == 17">C2~C3</span>
							<span v-if="scope.row.AQ101[0] == 18">C3~C4</span>
							<span v-if="scope.row.AQ101[0] == 19">C4~C5</span>
							<span v-if="scope.row.AQ101[0] == 20">C5~C6</span>
							<span v-if="scope.row.AQ101[0] == 21">C6~C7</span>
							<span v-if="scope.row.AQ101[0] == 22">C7~C8</span>
				        </div>
				        </el-popover>
					</template>
				</el-table-column>
				<el-table-column label="胸椎段"  width='100' prop="AQ1" :filters="AQ12Filt" column-key="AQ12">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
				          <p>
				          	<span v-for="item in scope.row.AQ102">
								<span v-if="item == 33">T1~T2</span>
								<span v-if="item == 34">T2~T3</span>
								<span v-if="item == 35">T3~T4</span>
								<span v-if="item == 36">T4~T5</span>
								<span v-if="item == 37">T5~T6</span>
								<span v-if="item == 38">T6~T7</span>
								<span v-if="item == 39">T7~T8</span>
								<span v-if="item == 40">T8~T9</span>
								<span v-if="item == 41">T9~T10</span>
								<span v-if="item == 42">T10~T11</span>
								<span v-if="item == 43">T11~T12</span>
							</span>
				          </p>
				          <div slot="reference" class="name-wrapper">
				           	<span v-if="scope.row.AQ102[0] == 33">T1~T2</span>
							<span v-if="scope.row.AQ102[0] == 34">T2~T3</span>
							<span v-if="scope.row.AQ102[0] == 35">T3~T4</span>
							<span v-if="scope.row.AQ102[0] == 36">T4~T5</span>
							<span v-if="scope.row.AQ102[0] == 37">T5~T6</span>
							<span v-if="scope.row.AQ102[0] == 38">T6~T7</span>
							<span v-if="scope.row.AQ102[0] == 39">T7~T8</span>
							<span v-if="scope.row.AQ102[0] == 40">T8~T9</span>
							<span v-if="scope.row.AQ102[0] == 41">T9~T10</span>
							<span v-if="scope.row.AQ102[0] == 42">T10~T11</span>
							<span v-if="scope.row.AQ102[0] == 43">T11~T12</span>
				        </div>
				        </el-popover>
					</template>
				</el-table-column>
				<el-table-column label="腰椎段"  width='100' prop="AQ1" :filters="AQ13Filt" column-key="AQ13">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.AQ103">
								<span v-if="item == 49">L1~L2</span>
								<span v-if="item == 50">L2~L3</span>
								<span v-if="item == 51">L3~L4</span>
								<span v-if="item == 52">L4~L5</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.AQ103[0] == 49">L1~L2</span>
								<span v-if="scope.row.AQ103[0] == 50">L2~L3</span>
								<span v-if="scope.row.AQ103[0] == 51">L3~L4</span>
								<span v-if="scope.row.AQ103[0] == 52">L4~L5</span>	
						</div>
					</el-popover>
					</template>
				</el-table-column>
				<el-table-column label="骶椎段"  width='100' prop="AQ1" :filters="AQ14Filt" column-key="AQ14">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.AQ104">
								<span v-if="item == 65">S1~S2</span>
								<span v-if="item == 66">S2~S3</span>
								<span v-if="item == 67">S3~S4</span>
								<span v-if="item == 68">S4~S5</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
							<span v-if="scope.row.AQ104[0] == 65">S1~S2</span>
							<span v-if="scope.row.AQ104[0] == 66">S2~S3</span>
							<span v-if="scope.row.AQ104[0] == 67">S3~S4</span>
							<span v-if="scope.row.AQ104[0] == 68">S4~S5</span>	
						</div>
						</el-popover>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="其他病种" width='150' prop="AQ2" :filters="AQ2Filt" column-key="AQ2">
				<template slot-scope="scope">
					<span v-if="scope.row.AQ2">
						<el-popover trigger="hover" placement="top">
							<p>
							<span v-for="item in scope.row.AQ2">
								<span v-if="item == 1">脑卒中</span>
								<span v-if="item == 2">脑瘫</span>
								<span v-if="item == 3">原发性脊髓炎</span>
								<span v-if="item == 4">小儿麻痹</span>
								<span v-if="item == 5">创伤性脑损伤</span>
								<span v-if="item == 6">骨关节炎</span>
								<span v-if="item == 7">进行性肌营养不良</span>
								<span v-if="item == 8">帕金森综合症</span>
								<span v-if="item == 9">阿尔茨海默病(老年痴呆)</span>
								<span v-if="typeof item == 'string'">{{item}}</span>
							</span>
							</p>
							<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.AQ2[0] == 1">脑卒中</span>
								<span v-if="scope.row.AQ2[0] == 2">脑瘫</span>
								<span v-if="scope.row.AQ2[0] == 3">原发性脊髓炎</span>
								<span v-if="scope.row.AQ2[0] == 4">小儿麻痹</span>
								<span v-if="scope.row.AQ2[0] == 5">创伤性脑损伤</span>
								<span v-if="scope.row.AQ2[0] == 6">骨关节炎</span>
								<span v-if="scope.row.AQ2[0] == 7">进行性肌营养不良</span>
								<span v-if="scope.row.AQ2[0] == 8">帕金森综合症</span>
								<span v-if="scope.row.AQ2[0] == 9">阿尔茨海默病(老年痴呆)</span>
								<span v-if="typeof scope.row.AQ2[0] == 'string'">{{scope.row.AQ2[0]}}</span>
							</div>
						</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="适用判断">
				<el-table-column label="近期是否站立训练" width='90' prop="AQ3" :filters="AQ31Filt" column-key="AQ31">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ3[0] == 18">每天</span>
						<span v-if="scope.row.AQ3[0] == 19">偶尔</span>
						<span v-if="scope.row.AQ3[0] == 17">无</span>
					</template>
				</el-table-column>
				<el-table-column label="骨密度" width='80' prop="AQ3" :filters="AQ32Filt" column-key="AQ32">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ3[1] == 34">T≤1</span>
						<span v-if="scope.row.AQ3[1] == 35">1≤T≤2.5</span>
						<span v-if="scope.row.AQ3[1] == 36">T>2.5</span>
					</template>
				</el-table-column>
				<el-table-column label="痉挛等级" width='90' prop="AQ3" :filters="AQ33Filt" column-key="AQ33">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ3[2] == 50">0级</span>
						<span v-if="scope.row.AQ3[2] == 51">1级</span>
						<span v-if="scope.row.AQ3[2] == 52">2级</span>
						<span v-if="scope.row.AQ3[2] == 53">3级</span>
						<span v-if="scope.row.AQ3[2] == 54">4级</span>
						<span v-if="scope.row.AQ3[2] == 55">5级</span>
					</template>
				</el-table-column>
				<el-table-column label="上肢及手功能等级" width='90' prop="AQ3" :filters="AQ34Filt" column-key="AQ34">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ3[3] == 66">1级</span>
						<span v-if="scope.row.AQ3[3] == 67">2级</span>
						<span v-if="scope.row.AQ3[3] == 68">3级</span>
						<span v-if="scope.row.AQ3[3] == 69">4级</span>
						<span v-if="scope.row.AQ3[3] == 70">5级</span>
						<span v-if="scope.row.AQ3[3] == 71">6级</span>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="禁忌情况">
				<el-table-column label="体位性低血压" width='80' prop="AQ4" :filters="AQ41Filt" column-key="AQ41">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ4[0] == 16">否</span>
						<span v-if="scope.row.AQ4[0] == 17">是</span>
					</template>
				</el-table-column>
				<el-table-column label="脊柱侧弯" width='65' prop="AQ4" :filters="AQ42Filt" column-key="AQ42">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ4[1] == 32">否</span>
						<span v-if="scope.row.AQ4[1] == 33">是</span>
					</template>
				</el-table-column>
				<el-table-column label="关节严重变形" width='80' prop="AQ4" :filters="AQ43Filt" column-key="AQ43">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ4[2] == 48">否</span>
						<span v-if="scope.row.AQ4[2] == 49">是</span>
					</template>
				</el-table-column>
				<el-table-column label="长短腿" width='78' prop="AQ4" :filters="AQ44Filt" column-key="AQ44">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ4[3] == 64">否</span>
						<span v-if="scope.row.AQ4[3] == 65">是</span>
					</template>
				</el-table-column>
				<el-table-column label="认知障碍" width='70' prop="AQ4" :filters="AQ45Filt" column-key="AQ45">
					<template slot-scope="scope">
						<span v-if="scope.row.AQ4[4] == 80">否</span>
						<span v-if="scope.row.AQ4[4] == 81">是</span>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="受伤原因" width='90' prop="BQ1" :filters="BQ1Filt" column-key="BQ1">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ1">
						<span v-if="scope.row.BQ1 === 2">原发性</span>
						<span v-if="scope.row.BQ1 === 3">病毒感染</span>
						<span v-if="scope.row.BQ1 === 4">病变</span>
						<span v-if="scope.row.BQ1 === 5">意外事故</span>
						<span v-if="typeof scope.row.BQ1 == 'string'">{{scope.row.BQ1}}</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="政策福利" width='160' prop="BQ2" :filters="BQ2Filt" column-key="BQ2">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ2">
						<span v-for="item in scope.row.BQ2">
							<span v-if="item == 2">残联</span>
							<span v-if="item == 3">医保</span>
							<span v-if="item == 4">工伤</span>
							<span v-if="item == 5">自费</span>
							<span v-if="typeof item == 'string'">其他:{{item}}</span>
						</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="政府补贴额度" width='120' prop="BQ3" :filters="BQ3Filt" column-key="BQ3">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ3">
						<span v-if="scope.row.BQ3 == 1">无</span>
						<span v-if="scope.row.BQ3 == 2">0-3千</span>
						<span v-if="scope.row.BQ3 == 3">3-6千</span>
						<span v-if="scope.row.BQ3 == 4">6-9千</span>
						<span v-if="scope.row.BQ3 == 5">9千-1.5万</span>
						<span v-if="scope.row.BQ3 == 6">1.5-2万</span>
						<span v-if="scope.row.BQ3 == 7">2-3万</span>
						<span v-if="scope.row.BQ3 == 8">3万以上</span>
						<span v-if="scope.row.BQ3 == 9">全额</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="目前使用的轮椅" >
				<el-table-column label="类型" width='135' prop="BQ4" :filters="BQ4Filt" column-key="BQ4">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ4">
							<span v-if="scope.row.BQ4 == 2">手动轮椅</span>
							<span v-if="scope.row.BQ4 == 3">电动轮椅</span>
							<span v-if="scope.row.BQ4 == 4">手动和电动轮椅</span>
							<span v-if="typeof scope.row.BQ4 == 'string'">其他：{{scope.row.BQ4}}</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="品牌" width='120' prop="BQ5" :filters="BQ5Filt" column-key="BQ5">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ5">
							<el-popover trigger="hover" placement="top">
					        	<p>
									<span v-for="item in scope.row.BQ5">
										<span v-if="item == 2">奥托博克</span>
										<span v-if="item == 3">英维康</span>
										<span v-if="item == 4">鱼跃</span>
										<span v-if="item == 5">凯洋</span>
										<span v-if="item == 6">卫美恒</span>
										<span v-if="item == 7">巴森巴乔</span>
										<span v-if="item == 8">威之群</span>
										<span v-if="item == 9">康扬</span>
										<span v-if="item == 10">互邦</span>
										<span v-if="item == 11">Ti</span>
										<span v-if="item == 12">松永</span>
										<span v-if="item == 13">搏动</span>
										<span v-if="typeof item == 'string'">其他:{{item}}</span>
									</span>
								</p>
					          	<div slot="reference" class="name-wrapper">
									<span v-if="scope.row.BQ5[0] == 2">奥托博克</span>
									<span v-if="scope.row.BQ5[0] == 3">英维康</span>
									<span v-if="scope.row.BQ5[0] == 4">鱼跃</span>
									<span v-if="scope.row.BQ5[0] == 5">凯洋</span>
									<span v-if="scope.row.BQ5[0] == 6">卫美恒</span>
									<span v-if="scope.row.BQ5[0] == 7">巴森巴乔</span>
									<span v-if="scope.row.BQ5[0] == 8">威之群</span>
									<span v-if="scope.row.BQ5[0] == 9">康扬</span>
									<span v-if="scope.row.BQ5[0] == 10">互邦</span>
									<span v-if="scope.row.BQ5[0] == 11">Ti</span>
									<span v-if="scope.row.BQ5[0] == 12">松永</span>
									<span v-if="scope.row.BQ5[0] == 13">搏动</span>
									<span v-if="typeof scope.row.BQ5[0] == 'string'">其他:{{scope.row.BQ5[0]}}</span>	
								</div>
					        </el-popover>
				        </span>
					</template>
				</el-table-column>
				<el-table-column label="价格" width='90' prop="BQ6" :filters="BQ6Filt" column-key="BQ6">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ6">
							<span v-if="scope.row.BQ6 == 2">5千以下</span>
							<span v-if="scope.row.BQ6 == 3">5千-1万</span>
							<span v-if="scope.row.BQ6 == 4">1-2万</span>
							<span v-if="scope.row.BQ6 == 5">2-3万</span>
							<span v-if="scope.row.BQ6 == 6">3-4万</span>
							<span v-if="scope.row.BQ6 == 7">4万以上</span>
						</span>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="医院康复训练费用" width='90' prop="BQ8" :filters="BQ8Filt" column-key="BQ8">
				<template slot-scope="scope">
					<span v-if="!scope.row.BQ8"></span>
					<span v-if="scope.row.BQ8 == 2">5千以下</span>
					<span v-if="scope.row.BQ8 == 3">5千-1万</span>
					<span v-if="scope.row.BQ8 == 4">1-2万</span>
					<span v-if="scope.row.BQ8 == 5">2-3万</span>
					<span v-if="scope.row.BQ8 == 6">3-4万</span>
					<span v-if="scope.row.BQ8 == 7">4万以上</span>
				</template>
			</el-table-column>
			<el-table-column label="现有康复器材">
				<el-table-column label="站立架" width='100' prop="BQ9" :filters="BQ91Filt" column-key="BQ91">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 18">200-400元</span>
								<span v-if="item == 19">400-600元</span>
								<span v-if="item == 20">600-800元</span>
								<span v-if="item == 21">800元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="站立床" width='100' prop="BQ9" :filters="BQ92Filt" column-key="BQ92">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 34">500-1000元</span>
								<span v-if="item == 35">1000-1500元</span>
								<span v-if="item == 36">1500-2000元</span>
								<span v-if="item == 37">2000元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="站立柜" width='100' prop="BQ9" :filters="BQ93Filt" column-key="BQ93">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 50">200-400元</span>
								<span v-if="item == 51">400-600元</span>
								<span v-if="item == 52">600-800元</span>
								<span v-if="item == 53">800元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="踝支具" width='100' prop="BQ9" :filters="BQ94Filt" column-key="BQ94">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 66">40-100元</span>
								<span v-if="item == 67">100-300元</span>
								<span v-if="item == 68">300-700元</span>
								<span v-if="item == 69">700元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="行走支具" width='100' prop="BQ9" :filters="BQ95Filt" column-key="BQ95">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 82">500-1000元</span>
								<span v-if="item == 83">1000-1500元</span>
								<span v-if="item == 84">1500-2000元</span>
								<span v-if="item == 85">2000元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="气动理疗仪" width='105' prop="BQ9" :filters="BQ96Filt" column-key="BQ96">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 98">100-300元</span>
								<span v-if="item == 99">300-600元</span>
								<span v-if="item == 100">600-1200元</span>
								<span v-if="item == 101">1200元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="磁疗仪" width='100' prop="BQ9" :filters="BQ97Filt" column-key="BQ97">
					<template slot-scope="scope">
						<span v-if="scope.row.BQ9">
							<span v-for="item in scope.row.BQ9">
								<span v-if="item == 114">50-200元</span>
								<span v-if="item == 115">200-400元</span>
								<span v-if="item == 116">400-800元</span>
								<span v-if="item == 117">800元以上</span>
							</span>
						</span>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="家中康复训练需求" width='150' prop="BQ10" :filters="BQ10Filt" column-key="BQ10">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ10">
						<el-popover trigger="hover" placement="top">
							<p>
						<span v-for="item in scope.row.BQ10">
							<span v-if="item == 2">站立训练</span>
							<span v-if="item == 3">行走训练</span>
							<span v-if="item == 4">蹲起训练</span>
							<span v-if="item == 5">跟腱拉伸训练</span>
							<span v-if="typeof item == 'string'">其他:{{item}}</span>
						</span>
							</p>
							<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.BQ10[0] == 2">站立训练</span>
								<span v-if="scope.row.BQ10[0] == 3">行走训练</span>
								<span v-if="scope.row.BQ10[0] == 4">蹲起训练</span>
								<span v-if="scope.row.BQ10[0] == 5">跟腱拉伸训练</span>
								<span v-if="typeof scope.row.BQ10[0] == 'string'">其他:{{scope.row.BQ10[0]}}</span>
					        </div>
						</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="家务活动完成情况" width='150' prop="BQ11" :filters="BQ11Filt" column-key="BQ11">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ11">
					<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.BQ11">
								<span v-if="item == 2">做饭</span>
								<span v-if="item == 3">洗衣</span>
								<span v-if="item == 4">打扫卫生</span>
								<span v-if="item == 5">高低取物</span>
								<span v-if="item == 6">床-轮椅转移</span>
								<span v-if="item == 7">轮椅-马桶转移</span>
								<span v-if="item == 8">康复训练</span>
								<span v-if="typeof item == 'string'">其他:{{item}}</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.BQ11[0] == 2">做饭</span>
								<span v-if="scope.row.BQ11[0] == 3">洗衣</span>
								<span v-if="scope.row.BQ11[0] == 4">打扫卫生</span>
								<span v-if="scope.row.BQ11[0] == 5">高低取物</span>
								<span v-if="scope.row.BQ11[0] == 6">床-轮椅转移</span>
								<span v-if="scope.row.BQ11[0] == 7">轮椅-马桶转移</span>
								<span v-if="scope.row.BQ11[0] == 8">康复训练</span>
								<span v-if="typeof scope.row.BQ11[0] == 'string'">其他:{{scope.row.BQ11[0]}}</span>
				        </div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="短距离出行工具" width='140' prop="BQ12" :filters="BQ12Filt" column-key="BQ12">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ12">
					<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.BQ12">
								<span v-if="item == 2">电动轮椅</span>
								<span v-if="item == 3">手动轮椅</span>
								<span v-if="item == 4">代步车</span>
								<span v-if="item == 5">汽车</span>
								<span v-if="typeof item == 'string'">其他:{{item}}</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.BQ12[0] == 2">电动轮椅</span>
								<span v-if="scope.row.BQ12[0] == 3">手动轮椅</span>
								<span v-if="scope.row.BQ12[0] == 4">代步车</span>
								<span v-if="scope.row.BQ12[0] == 5">汽车</span>
								<span v-if="typeof scope.row.BQ12[0] == 'string'">其他:{{scope.row.BQ12[0]}}</span>
						</div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="远距离出行工具" width='140' prop="BQ13" :filters="BQ13Filt" column-key="BQ13">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ13">
					<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.BQ13">
								<span v-if="item == 2">电动轮椅</span>
								<span v-if="item == 3">手动轮椅</span>
								<span v-if="item == 4">代步车</span>
								<span v-if="item == 5">汽车</span>
								<span v-if="typeof item == 'string'">其他:{{item}}</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.BQ13[0] == 2">电动轮椅</span>
								<span v-if="scope.row.BQ13[0] == 3">手动轮椅</span>
								<span v-if="scope.row.BQ13[0] == 4">代步车</span>
								<span v-if="scope.row.BQ13[0] == 5">汽车</span>
								<span v-if="typeof scope.row.BQ13[0] == 'string'">其他:{{scope.row.BQ12[0]}}</span>
						</div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="爱好" width='100' prop="BQ14" :filters="BQ14Filt" column-key="BQ14">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ14">
					<el-popover trigger="hover" placement="top">
						<p>
							<span v-for="item in scope.row.BQ14">
								<span v-if="item == 2">手游(王者荣耀等)</span>
								<span v-if="item == 3">网游(LOL绝地求生等)</span>
								<span v-if="item == 4">看电视</span>
								<span v-if="item == 5">电影</span>
								<span v-if="item == 6">唱歌</span>
								<span v-if="item == 7">跳舞</span>
								<span v-if="item == 8">驾驶</span>
								<span v-if="item == 9">旅游</span>
								<span v-if="item == 10">读书</span>
								<span v-if="item == 11">烹饪</span>
								<span v-if="item == 12">绘画</span>
								<span v-if="typeof item == 'string'">其他:{{item}}</span>
							</span>
						</p>
						<div slot="reference" class="name-wrapper">
							<span v-if="scope.row.BQ14[0] == 2">手游</span>
								<span v-if="scope.row.BQ14[0] == 3">网游</span>
								<span v-if="scope.row.BQ14[0] == 4">看电视</span>
								<span v-if="scope.row.BQ14[0] == 5">电影</span>
								<span v-if="scope.row.BQ14[0] == 6">唱歌</span>
								<span v-if="scope.row.BQ14[0] == 7">跳舞</span>
								<span v-if="scope.row.BQ14[0] == 8">驾驶</span>
								<span v-if="scope.row.BQ14[0] == 9">旅游</span>
								<span v-if="scope.row.BQ14[0] == 10">读书</span>
								<span v-if="scope.row.BQ14[0] == 11">烹饪</span>
								<span v-if="scope.row.BQ14[0] == 12">绘画</span>
								<span v-if="typeof scope.row.BQ14[0] == 'string'">其他:{{scope.row.BQ14[0]}}</span>
						</div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="康复新闻渠道" width='120' prop="BQ15" :filters="BQ15Filt" column-key="BQ15">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ15">
					<el-popover trigger="hover" placement="top">
						<p>
					<span v-for="item in scope.row.BQ15">
						<span v-if="item == 2">微信</span>
						<span v-if="item == 3">公众号</span>
						<span v-if="item == 4">微博</span>
						<span v-if="item == 5">QQ</span>
						<span v-if="item == 6">论坛</span>
						<span v-if="item == 7">政府网站</span>
						<span v-if="item == 8">电台</span>
						<span v-if="item == 9">百度</span>
						<span v-if="item == 10">今日头条</span>
						<span v-if="item == 11">网易新闻</span>
						<span v-if="item == 12">腾讯新闻</span>
						<span v-if="typeof item == 'string'">其他:{{item}}</span>
					</span>
					</p>
						<div slot="reference" class="name-wrapper">
							<span v-if="scope.row.BQ15[0] == 2">微信</span>
							<span v-if="scope.row.BQ15[0] == 3">公众号</span>
							<span v-if="scope.row.BQ15[0] == 4">微博</span>
							<span v-if="scope.row.BQ15[0] == 5">QQ</span>
							<span v-if="scope.row.BQ15[0] == 6">论坛</span>
							<span v-if="scope.row.BQ15[0] == 7">政府网站</span>
							<span v-if="scope.row.BQ15[0] == 8">电台</span>
							<span v-if="scope.row.BQ15[0] == 9">百度</span>
							<span v-if="scope.row.BQ15[0] == 10">今日头条</span>
							<span v-if="scope.row.BQ15[0] == 11">网易新闻</span>
							<span v-if="scope.row.BQ15[0] == 12">腾讯新闻</span>
							<span v-if="typeof scope.row.BQ15[0] == 'string'">其他:{{scope.row.BQ15[0]}}</span>
						</div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="如厕解决办法" width='120' prop="BQ16" :filters="BQ16Filt" column-key="BQ16">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ16">
					<el-popover trigger="hover" placement="top">
						<p>
					<span v-for="item in scope.row.BQ16">
						<span v-if="item == 2">大小便护理器</span>
						<span v-if="item == 3">家人</span>
						<span v-if="item == 4">护工</span>
						<span v-if="item == 5">自己</span>
					</span>
						</p>
						<div slot="reference" class="name-wrapper">
							<span v-if="scope.row.BQ16[0] == 2">大小便护理器</span>
							<span v-if="scope.row.BQ16[0] == 3">家人</span>
							<span v-if="scope.row.BQ16[0] == 4">护工</span>
							<span v-if="scope.row.BQ16[0] == 5">自己</span>
						</div>
					</el-popover>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="护工雇佣情况" width='80' prop="BQ17" :filters="BQ17Filt" column-key="BQ17">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ17">
						<span v-if="scope.row.BQ17 == 1">无</span>
						<span v-if="scope.row.BQ17 == 2">以前有</span>
						<span v-if="scope.row.BQ17 == 3">正在雇佣</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="护工年费用" width='80' prop="BQ18" :filters="BQ18Filt" column-key="BQ18">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ18">
						<span v-if="scope.row.BQ18 == 1">无</span>
						<span v-if="scope.row.BQ18 == 2">4-5万</span>
						<span v-if="scope.row.BQ18 == 3">5-6万</span>
						<span v-if="scope.row.BQ18 == 4">6-7万</span>
						<span v-if="scope.row.BQ18 == 5">7-8万</span>
						<span v-if="scope.row.BQ18 == 6">10万以上</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="个人月收入" width='105'  prop="BQ19" :filters="BQ19Filt" column-key="BQ19">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ19">
						<span v-if="scope.row.BQ19 == 1">无</span>
						<span v-if="scope.row.BQ19 == 2">4千以下</span>
						<span v-if="scope.row.BQ19 == 3">4-8千</span>
						<span v-if="scope.row.BQ19 == 4">8千-1.2万</span>
						<span v-if="scope.row.BQ19 == 5">1.2万以上</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="医疗设备年投入" width='80' prop="BQ20" :filters="BQ20Filt" column-key="BQ20">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ20">
						<span v-if="scope.row.BQ20 == 2">5千以下</span>
						<span v-if="scope.row.BQ20 == 3">5千-1万</span>
						<span v-if="scope.row.BQ20 == 4">1-2万</span>
						<span v-if="scope.row.BQ20 == 5">2-4万</span>
						<span v-if="scope.row.BQ20 == 6">4-8万</span>
						<span v-if="scope.row.BQ20 == 7">8万以上</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="家庭人口数" width='105' prop="BQ21" :filters="BQ21Filt" column-key="BQ21">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ21">
						<span v-if="scope.row.BQ21 == 2">2人及以下</span>
						<span v-if="scope.row.BQ21 == 3">3人</span>
						<span v-if="scope.row.BQ21 == 4">4人</span>
						<span v-if="scope.row.BQ21 == 5">4人以上</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="家庭年收入" width='105' prop="BQ22" :filters="BQ22Filt" column-key="BQ22">
				<template slot-scope="scope">
					<span v-if="scope.row.BQ22">
						<span v-if="scope.row.BQ22 == 2">6万以下</span>
						<span v-if="scope.row.BQ22 == 3">6-12万</span>
						<span v-if="scope.row.BQ22 == 4">12-20万</span>
						<span v-if="scope.row.BQ22 == 5">20万以上</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column width="100" label="备注" prop="remark">
				<template slot-scope="scope">
					<span v-if="scope.row.remark">
						<el-popover trigger="hover" placement="top">
							<p>
								<span v-if="scope.row.remark">{{scope.row.remark}}</span>
								<span v-if="!scope.row.remark">无</span>
							</p>
							<div slot="reference" class="name-wrapper">
								<span v-if="scope.row.remark">
									<span v-if="scope.row.remark.length < 6">{{scope.row.remark}}</span>
									<span v-if="scope.row.remark.length >= 7">查看</span>
								</span>
								<span v-if="!scope.row.remark">无</span>
							</div>
						</el-popover>
					</span>
				</template>
			</el-table-column>
		    <el-table-column label="操作" v-if="Limits.questionnaire_delete">
		    	<template slot-scope="scope">
		    		<el-button size="mini" type="danger" @click="Deldata(scope.$index,scope.row)" icon="el-icon-delete"></el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column label="操作" fixed="right" width="120" v-if="Limits.questionnaire_getReferralUrl">
		    	<template slot-scope="scope">
		    		<el-button size="mini" type="primary" @click="downQrcode(scope.$index,scope.row)">生成二维码</el-button>
		    	</template>
		    </el-table-column>
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<el-button type="primary" @click="DownExcel" size="small">导出到Excel</el-button>
			<el-pagination :span="20" layout="total,sizes,prev, pager, next" @current-change="handleCurrentChange"  @size-change="handleSizeChange" :page-size="Pagesize" :page-sizes="[20, 50]" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		
		<el-dialog title="信息修改" :visible.sync="ChangeVisible" width="800px" top="3%">
  			<el-form :model="Cform">
	    		<el-form-item label="姓名" :label-width="formLabelWidth">
	      			<el-input v-model="Cform.name" auto-complete="off" size="small" :style="inputWidth"></el-input>
	    		</el-form-item>
	    		<el-form-item label="性别" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.gender" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.gender" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="电话" :label-width="formLabelWidth">
	      			<el-input v-model="Cform.phone" type="phone" auto-complete="off" size="small" :maxlength="11" :style="inputWidth"></el-input>
	    		</el-form-item>
	    		<el-form-item label="出生年月" :label-width="formLabelWidth">
	    			<el-date-picker v-model="Cform.birth" type="month" placeholder="选择月" value-format="timestamp" size="small" :style="inputWidth"></el-date-picker>
	    		</el-form-item>
	    		<el-form-item label="身高(cm)" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.height" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in 101" :key="item" :value="item + 99">{{item + 99}}cm</el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="体重(kg)" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.weight" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in 111" :key="item" :value='item + 19'>{{item + 19}}kg</el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="腰围(cm)" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.waist" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in 201" :key="item" :value='item + 19'>{{item + 19}}cm</el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="学历" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.edu" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.edu" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="工作" :label-width="formLabelWidth">
	      			<el-select v-model="Cform.job" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.job" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="受伤时间" :label-width="formLabelWidth">
	    			<el-date-picker v-model="Cform.injurytime" type="month" placeholder="选择月" value-format="timestamp" size="small" :style="inputWidth"></el-date-picker>
	    		</el-form-item>
	    		<el-form-item label="地址" :label-width="formLabelWidth">
					<el-cascader size="small" expand-trigger="hover" :options="Addoptions" v-model="Cform.addr" :style="inputWidth"></el-cascader>
	    		</el-form-item>
	    		<h3>脊髓损伤</h3>
	    		<el-form-item label="颈椎段" :label-width="formLabelWidth">
	    			<el-checkbox-group v-model="Cform.jzarr" >
						<el-checkbox v-for="item in radioArr.AQ11" :key="item.value" :label='item.value'>{{item.text}}</el-checkbox>
					</el-checkbox-group>
	    		</el-form-item>
	    		<el-form-item label="胸椎段" :label-width="formLabelWidth">
	    			<el-checkbox-group v-model="Cform.jzarr" >
	    				<el-checkbox v-for="item in radioArr.AQ12" :key="item.value" :label='item.value'>{{item.text}}</el-checkbox>
					</el-checkbox-group>
	    		</el-form-item>
	    		<el-form-item label="腰椎段" :label-width="formLabelWidth">
	    			<el-checkbox-group v-model="Cform.jzarr" >
	    				<el-checkbox v-for="item in radioArr.AQ13" :key="item.value" :label='item.value'>{{item.text}}</el-checkbox>
					</el-checkbox-group>
	    		</el-form-item>
	    		<el-form-item label="腰椎段" :label-width="formLabelWidth">
	    			<el-checkbox-group v-model="Cform.jzarr" >
	    				<el-checkbox v-for="item in radioArr.AQ14" :key="item.value" :label='item.value'>{{item.text}}</el-checkbox>
					</el-checkbox-group>
	    		</el-form-item>
	    		<h3>其他病种</h3>
	    		<el-form-item label="其他病种" :label-width="formLabelWidth">
	    			<el-checkbox-group v-model="Cform.otarr2" >
	    				<el-checkbox v-for="item in radioArr.AQ2" :key="item.value" :label='item.value'>{{item.text}}</el-checkbox>
					</el-checkbox-group>
	    		</el-form-item>
	    		<el-form-item label="其他" :label-width="formLabelWidth">
	      			<el-input v-model="Cform.otherInput" auto-complete="off" size="small" :style="inputWidth"></el-input>
	    		</el-form-item>
	    		<h3>适用判断</h3>
	    		<el-form-item label="近3个月站立训练" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.apply1" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ31" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="近3个月骨密度" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.apply2" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ32" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="痉挛等级" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.apply3" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ33" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="上肢及手功能等级" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.apply4" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ34" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<h3>禁忌情况</h3>
	    		<el-form-item label="体位性低血压" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.tabu1" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ41" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="脊柱侧弯？" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.tabu2" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ42" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="关节严重变形" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.tabu3" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ43" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="长短腿" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.tabu4" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ44" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		<el-form-item label="认知障碍" :label-width="formLabelWidth2">
	      			<el-select v-model="Cform.tabu5" placeholder="请选择性别" size="small" :style="inputWidth">
    					<el-option v-for="item in radioArr.AQ45" :key="item.value" :label="item.lable" :value="item.value"></el-option>
  					</el-select>
	    		</el-form-item>
	    		
  			</el-form>
		  	<div slot="footer" class="dialog-footer">
			    <el-button @click="ChangeVisible = false">取 消</el-button>
			    <el-button type="primary" @click="subChangeData">确认修改并提交</el-button>
		  	</div>
		  	
		  	
</el-dialog>
			<el-dialog title="二维码" :visible.sync="qrcodeVisible" width="300px">
  				<div id="qrcodediv"></div>
  				<el-form>
  					<el-form-item label="二维码命名：" label-width="120">
      					<el-input v-model="qrcodeName"></el-input>
    				</el-form-item>
  				</el-form>
  				<a id="download" :download="qrcodeName"></a>
  				<span slot="footer" class="dialog-footer">
			    	<el-button @click="qrcodeVisible = false">取 消</el-button>
			    	<el-button type="primary" @click="downIt">下 载</el-button>
			  	</span>
			</el-dialog>
		
	
	</div>
</template>

<script>
	import moment from 'moment'
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	import {GetUsersDetail} from '../api/api';
	
	
	export default {
		data(){
			return {
				Limits:"",
				qrcodeVisible:false,
				codename:"",
				qrcodeName:"",
				token:"vhnN-p0w6fzXK8LCWLQSFCySPoRNImk0_1515828675",
				ChangeVisible:false,
				Cform:{
					name:"",
					gender:"",
					birth:"",
					height:"",
					weight:"",
					waist:"",
					edu:"",
					job:"",
					injurytime:"",
					phone:"",
					addr:[],
					jzarr:[],
					otarr:[],
					otarr2:[],
					otherInput:"",
					apply1:"",
					apply2:"",
					apply3:"",
					apply4:"",
					tabu1:"",
					tabu2:"",
					tabu3:"",
					tabu4:"",
					tabu5:"",
				},
				formLabelWidth:"80px",
				formLabelWidth2:"130px",
				inputWidth:"width:300px",
				center:'center',
				maxHeight:500,
				BirthTime:"",
				HurtTime:"",
				CustWaitLine1:"",
				CustWaitLine2:"",
				CustHeight1:"",
				CustHeight2:"",
				CustWeight1:"",
				CustWeight2:"",
				CustName:"",
				CustPhone:"",
				BetweenData:{},
				LastBetween:{},
				List:[],
				List8:[],
				listloading:false,
				Pagesize:20,
				Curpage:1,
				total:40,
				UserDetail:false,
				List2:[],
				listloading2:false,
				List3:{},
				listloading3:false,
				Form:{},
				delform:{},
				lastAll:{},
				Thelastest:{},
				Thelastest2:{},
				Screenall:{},
				Betweenall:{},
				AddrSelect:[],
				Addoptions:[{"value":"北京市","label":"北京市","children":[{"value":"东城区","label":"东城区"},{"value":"西城区","label":"西城区"},{"value":"崇文区","label":"崇文区"},{"value":"宣武区","label":"宣武区"},{"value":"朝阳区","label":"朝阳区"},{"value":"丰台区","label":"丰台区"},{"value":"石景山区","label":"石景山区"},{"value":"海淀区","label":"海淀区"},{"value":"门头沟区","label":"门头沟区"},{"value":"房山区","label":"房山区"},{"value":"通州区","label":"通州区"},{"value":"顺义区","label":"顺义区"},{"value":"昌平区","label":"昌平区"},{"value":"大兴区","label":"大兴区"},{"value":"怀柔区","label":"怀柔区"},{"value":"平谷区","label":"平谷区"},{"value":"密云县","label":"密云县"},{"value":"延庆县","label":"延庆县"},{"value":"延庆镇","label":"延庆镇"}]},{"value":"天津市","label":"天津市","children":[{"value":"和平区","label":"和平区"},{"value":"河东区","label":"河东区"},{"value":"河西区","label":"河西区"},{"value":"南开区","label":"南开区"},{"value":"河北区","label":"河北区"},{"value":"红桥区","label":"红桥区"},{"value":"塘沽区","label":"塘沽区"},{"value":"汉沽区","label":"汉沽区"},{"value":"大港区","label":"大港区"},{"value":"东丽区","label":"东丽区"},{"value":"西青区","label":"西青区"},{"value":"津南区","label":"津南区"},{"value":"北辰区","label":"北辰区"},{"value":"武清区","label":"武清区"},{"value":"宝坻区","label":"宝坻区"},{"value":"蓟县","label":"蓟县"},{"value":"宁河县","label":"宁河县"},{"value":"芦台镇","label":"芦台镇"},{"value":"静海县","label":"静海县"},{"value":"静海镇","label":"静海镇"}]},{"value":"上海市","label":"上海市","children":[{"value":"黄浦区","label":"黄浦区"},{"value":"卢湾区","label":"卢湾区"},{"value":"徐汇区","label":"徐汇区"},{"value":"长宁区","label":"长宁区"},{"value":"静安区","label":"静安区"},{"value":"普陀区","label":"普陀区"},{"value":"闸北区","label":"闸北区"},{"value":"虹口区","label":"虹口区"},{"value":"杨浦区","label":"杨浦区"},{"value":"闵行区","label":"闵行区"},{"value":"宝山区","label":"宝山区"},{"value":"嘉定区","label":"嘉定区"},{"value":"浦东新区","label":"浦东新区"},{"value":"金山区","label":"金山区"},{"value":"松江区","label":"松江区"},{"value":"青浦区","label":"青浦区"},{"value":"南汇区","label":"南汇区"},{"value":"奉贤区","label":"奉贤区"},{"value":"崇明县","label":"崇明县"},{"value":"城桥镇","label":"城桥镇"}]},{"value":"重庆市","label":"重庆市","children":[{"value":"渝中区","label":"渝中区"},{"value":"大渡口区","label":"大渡口区"},{"value":"江北区","label":"江北区"},{"value":"沙坪坝区","label":"沙坪坝区"},{"value":"九龙坡区","label":"九龙坡区"},{"value":"南岸区","label":"南岸区"},{"value":"北碚区","label":"北碚区"},{"value":"万盛区","label":"万盛区"},{"value":"双桥区","label":"双桥区"},{"value":"渝北区","label":"渝北区"},{"value":"巴南区","label":"巴南区"},{"value":"万州区","label":"万州区"},{"value":"涪陵区","label":"涪陵区"},{"value":"黔江区","label":"黔江区"},{"value":"长寿区","label":"长寿区"},{"value":"合川市","label":"合川市"},{"value":"永川区市","label":"永川区市"},{"value":"江津市","label":"江津市"},{"value":"南川市","label":"南川市"},{"value":"綦江县","label":"綦江县"},{"value":"潼南县","label":"潼南县"},{"value":"铜梁县","label":"铜梁县"},{"value":"大足县","label":"大足县"},{"value":"荣昌县","label":"荣昌县"},{"value":"璧山县","label":"璧山县"},{"value":"垫江县","label":"垫江县"},{"value":"武隆县","label":"武隆县"},{"value":"丰都县","label":"丰都县"},{"value":"城口县","label":"城口县"},{"value":"梁平县","label":"梁平县"},{"value":"开县","label":"开县"},{"value":"巫溪县","label":"巫溪县"},{"value":"巫山县","label":"巫山县"},{"value":"奉节县","label":"奉节县"},{"value":"云阳县","label":"云阳县"},{"value":"忠县","label":"忠县"},{"value":"石柱土家族自治县","label":"石柱土家族自治县"},{"value":"彭水苗族土家族自治县","label":"彭水苗族土家族自治县"},{"value":"酉阳土家族苗族自治县","label":"酉阳土家族苗族自治县"},{"value":"秀山土家族苗族自治县","label":"秀山土家族苗族自治县"}]},{"value":"河北省","label":"河北省","children":[{"value":"石家庄市","label":"石家庄市"},{"value":"张家口市","label":"张家口市"},{"value":"承德市","label":"承德市"},{"value":"秦皇岛市","label":"秦皇岛市"},{"value":"唐山市","label":"唐山市"},{"value":"廊坊市","label":"廊坊市"},{"value":"保定市","label":"保定市"},{"value":"衡水市","label":"衡水市"},{"value":"沧州市","label":"沧州市"},{"value":"邢台市","label":"邢台市"},{"value":"邯郸市","label":"邯郸市"}]},{"value":"山西省","label":"山西省","children":[{"value":"太原市","label":"太原市"},{"value":"朔州市","label":"朔州市"},{"value":"大同市","label":"大同市"},{"value":"阳泉市","label":"阳泉市"},{"value":"长治市","label":"长治市"},{"value":"晋城市","label":"晋城市"},{"value":"忻州市","label":"忻州市"},{"value":"晋中市","label":"晋中市"},{"value":"临汾市","label":"临汾市"},{"value":"吕梁市","label":"吕梁市"},{"value":"运城市","label":"运城市"}]},{"value":"内蒙古自治区","label":"内蒙古自治区","children":[{"value":"呼和浩特市","label":"呼和浩特市"},{"value":"包头市","label":"包头市"},{"value":"乌海市","label":"乌海市"},{"value":"赤峰市","label":"赤峰市"},{"value":"通辽市","label":"通辽市"},{"value":"呼伦贝尔市","label":"呼伦贝尔市"},{"value":"鄂尔多斯市","label":"鄂尔多斯市"},{"value":"乌兰察布市","label":"乌兰察布市"},{"value":"巴彦淖尔市","label":"巴彦淖尔市"},{"value":"兴安盟","label":"兴安盟"},{"value":"锡林郭勒盟","label":"锡林郭勒盟"},{"value":"阿拉善盟","label":"阿拉善盟"}]},{"value":"辽宁省","label":"辽宁省","children":[{"value":"沈阳市","label":"沈阳市"},{"value":"朝阳市","label":"朝阳市"},{"value":"阜新市","label":"阜新市"},{"value":"铁岭市","label":"铁岭市"},{"value":"抚顺市","label":"抚顺市"},{"value":"本溪市","label":"本溪市"},{"value":"辽阳市","label":"辽阳市"},{"value":"鞍山市","label":"鞍山市"},{"value":"丹东市","label":"丹东市"},{"value":"大连市","label":"大连市"},{"value":"营口市","label":"营口市"},{"value":"盘锦市","label":"盘锦市"},{"value":"锦州市","label":"锦州市"},{"value":"葫芦岛市","label":"葫芦岛市"}]},{"value":"吉林省","label":"吉林省","children":[{"value":"长春市","label":"长春市"},{"value":"白城市","label":"白城市"},{"value":"松原市","label":"松原市"},{"value":"吉林市","label":"吉林市"},{"value":"四平市","label":"四平市"},{"value":"辽源市","label":"辽源市"},{"value":"通化市","label":"通化市"},{"value":"白山市","label":"白山市"},{"value":"延边州","label":"延边州"}]},{"value":"黑龙江省","label":"黑龙江省","children":[{"value":"哈尔滨市","label":"哈尔滨市"},{"value":"齐齐哈尔市","label":"齐齐哈尔市"},{"value":"七台河市","label":"七台河市"},{"value":"黑河市","label":"黑河市"},{"value":"大庆市","label":"大庆市"},{"value":"鹤岗市","label":"鹤岗市"},{"value":"伊春市","label":"伊春市"},{"value":"佳木斯市","label":"佳木斯市"},{"value":"双鸭山市","label":"双鸭山市"},{"value":"鸡西市","label":"鸡西市"},{"value":"牡丹江市","label":"牡丹江市"},{"value":"绥化市","label":"绥化市"},{"value":"大兴安岭地区","label":"大兴安岭地区"}]},{"value":"江苏省","label":"江苏省","children":[{"value":"南京市","label":"南京市"},{"value":"徐州市","label":"徐州市"},{"value":"连云港市","label":"连云港市"},{"value":"宿迁市","label":"宿迁市"},{"value":"淮安市","label":"淮安市"},{"value":"盐城市","label":"盐城市"},{"value":"扬州市","label":"扬州市"},{"value":"泰州市","label":"泰州市"},{"value":"南通市","label":"南通市"},{"value":"镇江市","label":"镇江市"},{"value":"常州市","label":"常州市"},{"value":"无锡市","label":"无锡市"},{"value":"苏州市","label":"苏州市"}]},{"value":"浙江省","label":"浙江省","children":[{"value":"杭州市","label":"杭州市"},{"value":"湖州市","label":"湖州市"},{"value":"嘉兴市","label":"嘉兴市"},{"value":"舟山市","label":"舟山市"},{"value":"宁波市","label":"宁波市"},{"value":"绍兴市","label":"绍兴市"},{"value":"衢州市","label":"衢州市"},{"value":"金华市","label":"金华市"},{"value":"台州市","label":"台州市"},{"value":"温州市","label":"温州市"},{"value":"丽水市","label":"丽水市"}]},{"value":"安徽省","label":"安徽省","children":[{"value":"合肥市","label":"合肥市"},{"value":"宿州市","label":"宿州市"},{"value":"淮北市","label":"淮北市"},{"value":"亳州市","label":"亳州市"},{"value":"阜阳市","label":"阜阳市"},{"value":"蚌埠市","label":"蚌埠市"},{"value":"淮南市","label":"淮南市"},{"value":"滁州市","label":"滁州市"},{"value":"马鞍山市","label":"马鞍山市"},{"value":"芜湖市","label":"芜湖市"},{"value":"铜陵市","label":"铜陵市"},{"value":"安庆市","label":"安庆市"},{"value":"黄山市","label":"黄山市"},{"value":"六安市","label":"六安市"},{"value":"巢湖市","label":"巢湖市"},{"value":"池州市","label":"池州市"},{"value":"宣城市","label":"宣城市"}]},{"value":"福建省","label":"福建省","children":[{"value":"福州市","label":"福州市"},{"value":"南平市","label":"南平市"},{"value":"莆田市","label":"莆田市"},{"value":"三明市","label":"三明市"},{"value":"泉州市","label":"泉州市"},{"value":"厦门市","label":"厦门市"},{"value":"漳州市","label":"漳州市"},{"value":"龙岩市","label":"龙岩市"},{"value":"宁德市","label":"宁德市"}]},{"value":"江西省","label":"江西省","children":[{"value":"南昌市","label":"南昌市"},{"value":"九江市","label":"九江市"},{"value":"景德镇市","label":"景德镇市"},{"value":"鹰潭市","label":"鹰潭市"},{"value":"新余市","label":"新余市"},{"value":"萍乡市","label":"萍乡市"},{"value":"赣州市","label":"赣州市"},{"value":"上饶市","label":"上饶市"},{"value":"抚州市","label":"抚州市"},{"value":"宜春市","label":"宜春市"},{"value":"吉安市","label":"吉安市"}]},{"value":"山东省","label":"山东省","children":[{"value":"济南市","label":"济南市"},{"value":"青岛市","label":"青岛市"},{"value":"聊城市","label":"聊城市"},{"value":"德州市","label":"德州市"},{"value":"东营市","label":"东营市"},{"value":"淄博市","label":"淄博市"},{"value":"潍坊市","label":"潍坊市"},{"value":"烟台市","label":"烟台市"},{"value":"威海市","label":"威海市"},{"value":"日照市","label":"日照市"},{"value":"临沂市","label":"临沂市"},{"value":"枣庄市","label":"枣庄市"},{"value":"济宁市","label":"济宁市"},{"value":"泰安市","label":"泰安市"},{"value":"莱芜市","label":"莱芜市"},{"value":"滨州市","label":"滨州市"},{"value":"菏泽市","label":"菏泽市"}]},{"value":"河南省","label":"河南省","children":[{"value":"郑州市","label":"郑州市"},{"value":"开封市","label":"开封市"},{"value":"三门峡市","label":"三门峡市"},{"value":"洛阳市","label":"洛阳市"},{"value":"焦作市","label":"焦作市"},{"value":"新乡市","label":"新乡市"},{"value":"鹤壁市","label":"鹤壁市"},{"value":"安阳市","label":"安阳市"},{"value":"濮阳市","label":"濮阳市"},{"value":"商丘市","label":"商丘市"},{"value":"许昌市","label":"许昌市"},{"value":"漯河市","label":"漯河市"},{"value":"平顶山市","label":"平顶山市"},{"value":"南阳市","label":"南阳市"},{"value":"信阳市","label":"信阳市"},{"value":"周口市","label":"周口市"},{"value":"驻马店市","label":"驻马店市"},{"value":"济源市","label":"济源市"}]},{"value":"湖北省","label":"湖北省","children":[{"value":"武汉市","label":"武汉市"},{"value":"十堰市","label":"十堰市"},{"value":"襄樊市","label":"襄樊市"},{"value":"荆门市","label":"荆门市"},{"value":"孝感市","label":"孝感市"},{"value":"黄冈市","label":"黄冈市"},{"value":"鄂州市","label":"鄂州市"},{"value":"黄石市","label":"黄石市"},{"value":"咸宁市","label":"咸宁市"},{"value":"荆州市","label":"荆州市"},{"value":"宜昌市","label":"宜昌市"},{"value":"随州市","label":"随州市"},{"value":"恩施州","label":"恩施州"}]},{"value":"湖南省","label":"湖南省","children":[{"value":"长沙市","label":"长沙市"},{"value":"张家界市","label":"张家界市"},{"value":"常德市","label":"常德市"},{"value":"益阳市","label":"益阳市"},{"value":"岳阳市","label":"岳阳市"},{"value":"株洲市","label":"株洲市"},{"value":"湘潭市","label":"湘潭市"},{"value":"衡阳市","label":"衡阳市"},{"value":"郴州市","label":"郴州市"},{"value":"永州市","label":"永州市"},{"value":"邵阳市","label":"邵阳市"},{"value":"怀化市","label":"怀化市"},{"value":"娄底市","label":"娄底市"},{"value":"湘西州","label":"湘西州"}]},{"value":"广东省","label":"广东省","children":[{"value":"广州市","label":"广州市"},{"value":"深圳市","label":"深圳市"},{"value":"清远市","label":"清远市"},{"value":"韶关市","label":"韶关市"},{"value":"河源市","label":"河源市"},{"value":"梅州市","label":"梅州市"},{"value":"潮州市","label":"潮州市"},{"value":"汕头市","label":"汕头市"},{"value":"揭阳市","label":"揭阳市"},{"value":"汕尾市","label":"汕尾市"},{"value":"惠州市","label":"惠州市"},{"value":"东莞市","label":"东莞市"},{"value":"珠海市","label":"珠海市"},{"value":"中山市","label":"中山市"},{"value":"江门市","label":"江门市"},{"value":"佛山市","label":"佛山市"},{"value":"肇庆市","label":"肇庆市"},{"value":"云浮市","label":"云浮市"},{"value":"阳江市","label":"阳江市"},{"value":"茂名市","label":"茂名市"},{"value":"湛江市","label":"湛江市"}]},{"value":"广西壮族自治区","label":"广西壮族自治区","children":[{"value":"南宁市","label":"南宁市"},{"value":"桂林市","label":"桂林市"},{"value":"柳州市","label":"柳州市"},{"value":"梧州市","label":"梧州市"},{"value":"贵港市","label":"贵港市"},{"value":"玉林市","label":"玉林市"},{"value":"钦州市","label":"钦州市"},{"value":"北海市","label":"北海市"},{"value":"防城港市","label":"防城港市"},{"value":"崇左市","label":"崇左市"},{"value":"百色市","label":"百色市"},{"value":"河池市","label":"河池市"},{"value":"来宾市","label":"来宾市"},{"value":"贺州市","label":"贺州市"}]},{"value":"海南省","label":"海南省","children":[{"value":"海口市","label":"海口市"},{"value":"三亚市","label":"三亚市"}]},{"value":"四川省","label":"四川省","children":[{"value":"成都市","label":"成都市"},{"value":"广元市","label":"广元市"},{"value":"绵阳市","label":"绵阳市"},{"value":"德阳市","label":"德阳市"},{"value":"南充市","label":"南充市"},{"value":"广安市","label":"广安市"},{"value":"遂宁市","label":"遂宁市"},{"value":"内江市","label":"内江市"},{"value":"乐山市","label":"乐山市"},{"value":"自贡市","label":"自贡市"},{"value":"泸州市","label":"泸州市"},{"value":"宜宾市","label":"宜宾市"},{"value":"攀枝花市","label":"攀枝花市"},{"value":"巴中市","label":"巴中市"},{"value":"达州市","label":"达州市"},{"value":"资阳市","label":"资阳市"},{"value":"眉山市","label":"眉山市"},{"value":"雅安市","label":"雅安市"},{"value":"阿坝州","label":"阿坝州"},{"value":"甘孜州","label":"甘孜州"},{"value":"凉山州","label":"凉山州"}]},{"value":"贵州省","label":"贵州省","children":[{"value":"贵阳市","label":"贵阳市"},{"value":"六盘水市","label":"六盘水市"},{"value":"遵义市","label":"遵义市"},{"value":"安顺市","label":"安顺市"},{"value":"毕节地区","label":"毕节地区"},{"value":"铜仁地区","label":"铜仁地区"},{"value":"黔东南州","label":"黔东南州"},{"value":"黔南州","label":"黔南州"},{"value":"黔西南州","label":"黔西南州"}]},{"value":"云南省","label":"云南省","children":[{"value":"昆明市","label":"昆明市"},{"value":"曲靖市","label":"曲靖市"},{"value":"玉溪市","label":"玉溪市"},{"value":"保山市","label":"保山市"},{"value":"昭通市","label":"昭通市"},{"value":"丽江市","label":"丽江市"},{"value":"思茅市","label":"思茅市"},{"value":"临沧市","label":"临沧市"},{"value":"德宏州","label":"德宏州"},{"value":"怒江州","label":"怒江州"},{"value":"迪庆州","label":"迪庆州"},{"value":"大理州","label":"大理州"},{"value":"楚雄州","label":"楚雄州"},{"value":"红河州","label":"红河州"},{"value":"文山州","label":"文山州"},{"value":"西双版纳州","label":"西双版纳州"}]},{"value":"西藏自治区","label":"西藏自治区","children":[{"value":"拉萨市","label":"拉萨市"},{"value":"那曲地区","label":"那曲地区"},{"value":"昌都地区","label":"昌都地区"},{"value":"林芝地区","label":"林芝地区"},{"value":"山南地区","label":"山南地区"},{"value":"日喀则地区","label":"日喀则地区"},{"value":"阿里地区","label":"阿里地区"}]},{"value":"陕西省","label":"陕西省","children":[{"value":"西安市","label":"西安市"},{"value":"延安市","label":"延安市"},{"value":"铜川市","label":"铜川市"},{"value":"渭南市","label":"渭南市"},{"value":"咸阳市","label":"咸阳市"},{"value":"宝鸡市","label":"宝鸡市"},{"value":"汉中市","label":"汉中市"},{"value":"榆林市","label":"榆林市"},{"value":"安康市","label":"安康市"},{"value":"商洛市","label":"商洛市"}]},{"value":"甘肃省","label":"甘肃省","children":[{"value":"兰州市","label":"兰州市"},{"value":"嘉峪关市","label":"嘉峪关市"},{"value":"白银市","label":"白银市"},{"value":"天水市","label":"天水市"},{"value":"武威市","label":"武威市"},{"value":"酒泉市","label":"酒泉市"},{"value":"张掖市","label":"张掖市"},{"value":"庆阳市","label":"庆阳市"},{"value":"平凉市","label":"平凉市"},{"value":"定西市","label":"定西市"},{"value":"陇南市","label":"陇南市"},{"value":"临夏州","label":"临夏州"},{"value":"甘南州","label":"甘南州"}]},{"value":"青海省","label":"青海省","children":[{"value":"西宁市","label":"西宁市"},{"value":"海东地区","label":"海东地区"},{"value":"海北州","label":"海北州"},{"value":"海南州","label":"海南州"},{"value":"黄南州","label":"黄南州"},{"value":"果洛州","label":"果洛州"},{"value":"玉树州","label":"玉树州"},{"value":"海西州","label":"海西州"}]},{"value":"宁夏回族自治区","label":"宁夏回族自治区","children":[{"value":"银川市","label":"银川市"},{"value":"石嘴山市","label":"石嘴山市"},{"value":"吴忠市","label":"吴忠市"},{"value":"固原市","label":"固原市"},{"value":"中卫市","label":"中卫市"}]},{"value":"新疆维吾尔自治区","label":"新疆维吾尔自治区","children":[{"value":"乌鲁木齐市","label":"乌鲁木齐市"},{"value":"克拉玛依市","label":"克拉玛依市"},{"value":"喀什地区","label":"喀什地区"},{"value":"阿克苏地区","label":"阿克苏地区"},{"value":"和田地区","label":"和田地区"},{"value":"吐鲁番地区","label":"吐鲁番地区"},{"value":"哈密地区","label":"哈密地区"},{"value":"克孜勒苏柯州","label":"克孜勒苏柯州"},{"value":"博尔塔拉州","label":"博尔塔拉州"},{"value":"昌吉州","label":"昌吉州"},{"value":"巴音郭楞州","label":"巴音郭楞州"},{"value":"伊犁州","label":"伊犁州"},{"value":"塔城地区","label":"塔城地区"},{"value":"阿勒泰地区","label":"阿勒泰地区"}]},{"value":"香港","label":"香港","children":[{"value":"香港特别行政区","label":"香港特别行政区"}]},{"value":"澳门","label":"澳门","children":[{"value":"澳门特别行政区","label":"澳门特别行政区"}]},{"value":"台湾省","label":"台湾省","children":[{"value":"台北","label":"台北"},{"value":"高雄","label":"高雄"},{"value":"台中","label":"台中"},{"value":"花莲","label":"花莲"},{"value":"基隆","label":"基隆"},{"value":"嘉义","label":"嘉义"},{"value":"金门","label":"金门"},{"value":"连江","label":"连江"},{"value":"苗栗","label":"苗栗"},{"value":"南投","label":"南投"},{"value":"澎湖","label":"澎湖"},{"value":"屏东","label":"屏东"},{"value":"台东","label":"台东"},{"value":"台南","label":"台南"},{"value":"桃园","label":"桃园"},{"value":"新竹","label":"新竹"},{"value":"宜兰","label":"宜兰"},{"value":"云林","label":"云林"},{"value":"彰化","label":"彰化"}]}],
				Aedu:[{text:'小学',value:'小学'},{text:'初中',value:'初中'},{text:'高中',value:'高中'},{text:'中专',value:'中专'},{text:'大专',value:'大专'},{text:'本科',value:'本科'},{text:'硕士',value:'硕士'},{text:'博士',value:'博士'}],
				Agender:[{text:'男',value:'1'},{text:'女',value:'2'}],
				Ajob:[{text:'无',value:'1'},{text:'学生',value:'2'},{text:'文化/艺术',value:'3'},{text:'影视/娱乐',value:'4'},{text:'金融',value:'5'},{text:'医药/健康',value:'6'},{text:'工业/制造业',value:'7'},{text:'建筑',value:'8'},{text:'司机',value:'9'},{text:'公职',value:'10'},{text:'IT/互联网/通信',value:'11'},{text:'媒体/公关',value:'12'},{text:'零售',value:'13'},{text:'教育/科研',value:'14'}],
				AQ11Filt:[{text:'C2~C3',value:'17'},{text:'C3~C4',value:'18'},{text:'C4~C5',value:'19'},{text:'C5~C6',value:'20'},{text:'C6~C7',value:'21'},{text:'C7~C8',value:'22'}],
				AQ12Filt:[{text:'T1~T2',value:'33'},{text:'T2~T3',value:'34'},{text:'T3~T4',value:'35'},{text:'T4~T5',value:'36'},{text:'T5~T6',value:'37'},{text:'T6~T7',value:'38'},{text:'T7~T8',value:'39'},{text:'T8~T9',value:'40'},{text:'T9~T10',value:'41'},{text:'T10~T11',value:'42'},{text:'T11~T12',value:'43'}],
				AQ13Filt:[{text:'L1~L2',value:'49'},{text:'L2~L3',value:'50'},{text:'L3~L4',value:'51'},{text:'L4~L5',value:'52'}],
				AQ14Filt:[{text:'S1~S2',value:'65'},{text:'S2~S3',value:'66'},{text:'S3~S4',value:'67'},{text:'S4~S5',value:'68'}],
				AQ2Filt:[{text:'脑卒中',value:'1'},{text:'脑瘫',value:'2'},{text:'原发性脊髓炎',value:'3'},{text:'小儿麻痹',value:'4'},{text:'创伤性脑损伤',value:'5'},{text:'骨关节炎',value:'6'},{text:'进行性肌营养不良',value:'7'},{text:'帕金森综合征',value:'8'},{text:'阿尔兹海默病',value:'9'}],
				AQ31Filt:[{text:'每天',value:'18'},{text:'偶尔',value:'19'},{text:'无',value:'17'}],
				AQ32Filt:[{text:'T≤1',value:'34'},{text:'1≤T≤2.5',value:'35'},{text:'T>2.5',value:'36'}],
				AQ33Filt:[{text:'0级',value:'50'},{text:'1级',value:'51'},{text:'2级',value:'52'},{text:'3级',value:'53'},{text:'4级',value:'54'},{text:'5级',value:'55'}],
				AQ34Filt:[{text:'1级',value:'66'},{text:'2级',value:'67'},{text:'3级',value:'68'},{text:'4级',value:'69'},{text:'5级',value:'70'},{text:'6级',value:'71'}],
				AQ41Filt:[{text:'是',value:'17'},{text:'否',value:'16'}],
				AQ42Filt:[{text:'是',value:'33'},{text:'否',value:'32'}],
				AQ43Filt:[{text:'是',value:'49'},{text:'否',value:'48'}],
				AQ44Filt:[{text:'是',value:'65'},{text:'否',value:'64'}],
				AQ45Filt:[{text:'是',value:'81'},{text:'否',value:'80'}],
				BQ1Filt:[{text:'原发性',value:'2'},{text:'病毒感染',value:'3'},{text:'病变',value:'4'},{text:'意外事故',value:'5'}],
				BQ2Filt:[{text:'残联',value:'2'},{text:'医保',value:'3'},{text:'工伤',value:'4'},{text:'自费',value:'5'}],
				BQ3Filt:[{text:'无',value:'1'},{text:'0-3千',value:'2'},{text:'3-6千',value:'3'},{text:'6-9千',value:'4'},{text:'9千-1.5万',value:'5'},{text:'1.5-2万',value:'6'},{text:'2-3万',value:'7'},{text:'3万以上',value:'8'},{text:'全额',value:'9'}],
				BQ4Filt:[{text:'手动轮椅',value:'2'},{text:'电动轮椅',value:'3'},{text:'手动和电动轮椅',value:'4'}],
				BQ5Filt:[{text:'奥托博克',value:'2'},{text:'英维康',value:'3'},{text:'鱼跃',value:'4'},{text:'凯洋',value:'5'},{text:'卫美恒',value:'6'},{text:'巴森巴乔',value:'7'},{text:'威之群',value:'8'},{text:'康扬',value:'9'},{text:'互邦',value:'10'},{text:'Ti',value:'11'},{text:'松永',value:'12'},{text:'搏动',value:'13'}],
				BQ6Filt:[{text:'5千以下',value:'2'},{text:'5千-1万',value:'3'},{text:'1-2万',value:'4'},{text:'2-3万',value:'5'},{text:'3-4万',value:'6'},{text:'4万以上',value:'7'}],
				BQ8Filt:[{text:'无',value:'1'},{text:'5千以下',value:'2'},{text:'5千-1万',value:'3'},{text:'1-2万',value:'4'},{text:'2-3万',value:'5'},{text:'3-4万',value:'6'},{text:'4万以上',value:'7'}],
				BQ91Filt:[{text:'200-400元',value:'17'},{text:'400-600元',value:'18'},{text:'600-800元',value:'19'},{text:'800元以上',value:'20'}],
				BQ92Filt:[{text:'500-1000元',value:'33'},{text:'1000-1500元',value:'34'},{text:'1500-2000元',value:'35'},{text:'2000元以上',value:'36'}],
				BQ93Filt:[{text:'200-400元',value:'49'},{text:'400-600元',value:'50'},{text:'600-800元',value:'51'},{text:'800元以上',value:'52'}],
				BQ94Filt:[{text:'40-100元',value:'65'},{text:'100-300元',value:'66'},{text:'300-700元',value:'67'},{text:'700元以上',value:'68'}],
				BQ95Filt:[{text:'500-1000元',value:'81'},{text:'1000-1500元',value:'82'},{text:'1500-2000元',value:'83'},{text:'2000元以上',value:'84'}],
				BQ96Filt:[{text:'100-300元',value:'97'},{text:'300-600元',value:'98'},{text:'600-1200',value:'99'},{text:'1200元以上',value:'100'}],
				BQ97Filt:[{text:'50-200元',value:'114'},{text:'200-400元',value:'115'},{text:'400-800',value:'116'},{text:'800元以上',value:'117'}],
				BQ10Filt:[{text:'站立训练',value:'2'},{text:'行走训练',value:'3'},{text:'蹲起训练',value:'4'},{text:'跟腱拉伸训练',value:'5'}],
				BQ11Filt:[{text:'做饭',value:'2'},{text:'洗衣',value:'3'},{text:'打扫卫生',value:'4'},{text:'高低取物',value:'5'},{text:'床-轮椅转移',value:'6'},{text:'轮椅马桶转移',value:'7'},{text:'康复训练',value:'8'}],
				BQ12Filt:[{text:'电动轮椅',value:'2'},{text:'手动轮椅',value:'3'},{text:'代步车',value:'4'},{text:'汽车',value:'5'}],
				BQ13Filt:[{text:'电动轮椅',value:'2'},{text:'手动轮椅',value:'3'},{text:'代步车',value:'4'},{text:'汽车',value:'5'}],
				BQ14Filt:[{text:'手游',value:'2'},{text:'端游',value:'3'},{text:'电视剧',value:'4'},{text:'电影',value:'5'},{text:'唱歌',value:'6'},{text:'跳舞',value:'7'},{text:'驾驶',value:'8'},{text:'旅游',value:'9'},{text:'读书',value:'10'},{text:'烹饪',value:'11'},{text:'绘画',value:'12'}],
				BQ15Filt:[{text:'微信',value:'2'},{text:'公众号',value:'3'},{text:'微博',value:'4'},{text:'QQ',value:'5'},{text:'论坛',value:'6'},{text:'政府网站',value:'7'},{text:'电台',value:'8'},{text:'百度',value:'9'},{text:'今日头条',value:'10'},{text:'网易新闻',value:'11'},{text:'腾讯新闻',value:'12'}],
				BQ16Filt:[{text:'大小便护理器',value:'2'},{text:'家人',value:'3'},{text:'护工',value:'4'},{text:'自己',value:'5'}],
				BQ17Filt:[{text:'无',value:'1'},{text:'以前有',value:'2'},{text:'正在雇佣',value:'3'}],
				BQ18Filt:[{text:'无',value:'1'},{text:'4-5万',value:'2'},{text:'5-6万',value:'3'},{text:'6-7万',value:'4'},{text:'7-8万',value:'5'},{text:'10万以上',value:'6'}],
				BQ19Filt:[{text:'无',value:'1'},{text:'4千以下',value:'2'},{text:'4千~8千',value:'3'},{text:'8千~1.2万',value:'4'},{text:'1.2万以上',value:'5'}],
				BQ20Filt:[{text:'5千以下',value:'1'},{text:'5千~1万',value:'2'},{text:'1~2万',value:'3'},{text:'2万~4万',value:'4'},{text:'4万~8万',value:'5'},{text:'8万以上',value:'6'}],
				BQ21Filt:[{text:'2人及以下',value:'1'},{text:'3人',value:'2'},{text:'4人',value:'3'},{text:'4人以上',value:'4'},{text:'4万~8万',value:'5'},{text:'8万以上',value:'6'}],
				BQ22Filt:[{text:'6万以下',value:'1'},{text:'6-12万',value:'2'},{text:'12-20万',value:'3'},{text:'20万以上',value:'4'}],
				updata:0,
				lab:"",
				radiolist:[],
				radioArr:{
					"gender":[{value:1,lable:'男'},{value:2,lable:'女'}],
					"edu":[{value:'小学',lable:'小学'},{value:'初中',lable:'初中'},{value:'高中',lable:'高中'},{value:'中专',lable:'中专'},{value:'大专',lable:'大专'},{value:'本科',lable:'本科'},{value:'硕士',lable:'硕士'},{value:'博士',lable:'博士'}],
					"job":[{value:1,lable:'无'},{value:2,lable:'学生'},{value:3,lable:'文化/艺术'},{value:4,lable:'影视/娱乐'},{value:5,lable:'金融'},{value:6,lable:'医药/健康'},{value:7,lable:'工业/制造业'},{value:8,lable:'建筑'},{value:9,lable:'司机'},{value:10,lable:'公职'},{value:11,lable:'IT/互联网/通信'},{value:12,lable:'媒体/公关'},{value:13,lable:'零售'},{value:14,lable:'教育/科研'}],
					'AQ11':[{text:'C2~C3',value:17},{text:'C3~C4',value:18},{text:'C4~C5',value:19},{text:'C5~C6',value:20},{text:'C6~C7',value:21},{text:'C7~C8',value:22}],
					'AQ12':[{text:'T1~T2',value:33},{text:'T2~T3',value:34},{text:'T3~T4',value:35},{text:'T4~T5',value:36},{text:'T5~T6',value:37},{text:'T6~T7',value:38},{text:'T7~T8',value:39},{text:'T8~T9',value:40},{text:'T9~T10',value:41},{text:'T10~T11',value:42},{text:'T11~T12',value:43}],
					'AQ13':[{text:'L1~L2',value:49},{text:'L2~L3',value:50},{text:'L3~L4',value:51},{text:'L4~L5',value:52}],
					'AQ14':[{text:'S1~S2',value:65},{text:'S2~S3',value:66},{text:'S3~S4',value:67},{text:'S4~S5',value:68}],
					'AQ2':[{text:'脑卒中',value:1},{text:'脑瘫',value:2},{text:'原发性脊髓炎',value:3},{text:'小儿麻痹',value:4},{text:'创伤性脑损伤',value:5},{text:'骨关节炎',value:6},{text:'进行性肌营养不良',value:7},{text:'帕金森综合征',value:8},{text:'阿尔兹海默病',value:9}],
					"AQ31":[{value:17,lable:'无'},{value:18,lable:'每天'},{value:19,lable:'偶尔'}],
					"AQ32":[{value:34,lable:'T≤1'},{value:35,lable:'1≤T≤2.5'},{value:36,lable:'T＞2.5'},],
					"AQ33":[{value:50,lable:'0级（软瘫）'},{value:51,lable:'1级'},{value:52,lable:'2级'},{value:53,lable:'3级'},{value:54,lable:'4级'},{value:55,lable:'5级'}],
					"AQ34":[{value:66,lable:'1级'},{value:67,lable:'2级'},{value:68,lable:'3级'},{value:69,lable:'4级'},{value:70,lable:'5级'},{value:71,lable:'6级'}],
					"AQ41":[{value:17,lable:'是'},{value:16,lable:'否'}],
					"AQ42":[{value:33,lable:'是'},{value:32,lable:'否'}],
					"AQ43":[{value:49,lable:'是'},{value:48,lable:'否'}],
					"AQ44":[{value:65,lable:'是'},{value:64,lable:'否'}],
					"AQ45":[{value:81,lable:'是'},{value:80,lable:'否'}],
				},
				rowdata:{},
				AQ101:[],
				AQ102:[],
				AQ103:[],
				AQ104:[],
				pageCount:0
			}
		},
		methods:{
			DownExcel(){
				var that = this
//				console.log(that.pageCount)
//				for(var i=0 ;i<that.pageCount;i++){
//					that.Curpage = val
//					that.Quickfind()
//				}
				that.$prompt('请输入需要导出文件后的命名','提示',{
					confirmButtonText: '确定并导出',
          			cancelButtonText: '取消操作',
				}).then(({value}) => {
					that.exportExcelNew('#OnlyBox',value)
				})
			},
			exportExcelNew(id,title){
				var fix = document.querySelector('.el-table__fixed');
				  var wb;
				  if (fix) {
				    wb = XLSX.utils.table_to_book(document.querySelector(id).removeChild(fix));
				    document.querySelector(id).appendChild(fix);
				  } else {
				    wb = XLSX.utils.table_to_book(document.querySelector(id));
				  }
				  /* get binary string as output */
				  var wbout = XLSX.write(wb, {
				    bookType: 'xlsx',
				    bookSST: true,
				    type: 'array'
				  });
				  try {
				    FileSaver.saveAs(
				      new Blob([wbout], {
				        type: 'application/octet-stream'
				      }),
				      title + '.xlsx'
				    );
				  } catch (e) {
				    if (typeof console !== 'undefined') console.log(e, wbout);
				  }
				  return wbout;
			},
			ChangeIt(row, event){
				var that = this
				that.Cform.otarr2 = []
				that.Cform.otherInput = ""
				that.rowdata = row
				that.ChangeVisible = true
				that.Cform.name = row.name
				that.Cform.birth = row.birth
				that.Cform.gender = row.gender
				that.Cform.height = row.height
				that.Cform.weight = row.weight
				that.Cform.waist = row.waist
				that.Cform.edu = row.edu
				that.Cform.job = row.job
				that.Cform.injurytime = row.injurytime
				that.Cform.phone = row.phone
				that.Cform.addr = row.addr
				that.Cform.jzarr = row.AQ1
//				that.Cform.otarr = row.AQ2
				that.Cform.apply1 = row.AQ3[0]
				that.Cform.apply2 = row.AQ3[1]
				that.Cform.apply3 = row.AQ3[2]
				that.Cform.apply4 = row.AQ3[3]
				that.Cform.tabu1 = row.AQ4[0]
				that.Cform.tabu2 = row.AQ4[1]
				that.Cform.tabu3 = row.AQ4[2]
				that.Cform.tabu4 = row.AQ4[3]
				that.Cform.tabu5 = row.AQ4[4]
				
				for(var i=0;i<row.AQ2.length;i++){
					var tp = typeof(row.AQ2[i])
					if(tp == 'string'){
						that.Cform.otherInput = row.AQ2[i]
					}else{
						that.Cform.otarr2.push(row.AQ2[i])
					}
				}
			},
			subChangeData(){
				var that = this
//				姓名,电话,出生年月,受伤事件不能为空
				if(that.Cform.jzarr == "" || that.Cform.name == "" || that.Cform.phone == "" || that.Cform.birth == "" || that.Cform.injurytime == ""){
					that.$message({
			            type: 'success',
			            message: '请将信息填写完整后提交!'
			        });
				}else{
					var lastData = {}
					lastData.name = that.Cform.name
					lastData.birth = that.Cform.birth
					lastData.gender = that.Cform.gender
					lastData.height = that.Cform.height
					lastData.weight = that.Cform.weight
					lastData.waist = that.Cform.waist
					lastData.edu = that.Cform.edu
					lastData.job = that.Cform.job
					lastData.injurytime = that.Cform.injurytime
					lastData.phone = that.Cform.phone
					lastData.addr = that.Cform.addr
					lastData.AQ1 = that.Cform.jzarr
//					console.log("that.Cform.otarr",that.Cform.otarr)
					that.Cform.otarr = that.Cform.otarr2
					if(that.Cform.otherInput){
						that.Cform.otarr.push(that.Cform.otherInput)
					}
					lastData.AQ2 = that.Cform.otarr
					lastData.AQ3 = [that.Cform.apply1,that.Cform.apply2,that.Cform.apply3,that.Cform.apply4]
					lastData.AQ4 = [that.Cform.tabu1,that.Cform.tabu2,that.Cform.tabu3,that.Cform.tabu4,that.Cform.tabu5]
					
//					console.log("lastData",lastData)
					var lastUp = {}
					for(var i in lastData){
						if(Array.isArray(lastData[i])){
							if(lastData[i].length != that.rowdata[i].length){
								lastUp[i] = lastData[i]
							}else {
								var isOrno = JSON.stringify(lastData[i].sort()) == JSON.stringify(that.rowdata[i].sort())
								if(!isOrno){
									lastUp[i] = lastData[i]
								}
							}
						}else{
							if(lastData[i] != that.rowdata[i]){
								lastUp[i] = lastData[i]
							}
						}
					}
					console.log("lastUp",lastUp)
					let url = "/questionnaires/" + this.rowdata._id + '?token=' + that.token
					let param = lastUp
					that.axios.put(url,param).then(res => {
//						that.listloading = true
						if(res.status == "200"){
							that.ChangeVisible = false
							that.Quickfind()
							that.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
						}else{
							that.$message.error('对不起，请求失败。')
						}
					}).catch(err => {
						that.$message.error(err.response.data.message)
					})
				}
			},
//			生成二维码
			downQrcode(index,row){
				var that = this
				that.qrcodeVisible = true
				that.qrcodeName = ""
				$('#qrcodediv').empty()
				var thisForm = Object.assign({}, row)
				that.qrcodeName = thisForm.name
				that.axios.get('/questionnaires/' + thisForm._id + '/referral-url?token=' + that.token).then(res => {
//					console.log("二维码地址",res)
					if(res.data.url){
						jQuery('#qrcodediv').qrcode(res.data.url); 
					}else{
						that.$message.error("二维码获取失败")
					}
				}).catch(err => {
					that.$message.error(err.response.data.message)
					console.log(err)
				})
			},
//			下载二维码
			downIt(){
				var that = this
//				if(that.qrcodeName){
					that.codename = that.qrcodeName
					var canvas = $('#qrcodediv').find("canvas").get(0);
				    try {//解决IE转base64时缓存不足，canvas转blob下载
				        var blob = canvas.msToBlob();
				        navigator.msSaveBlob(blob, that.qrcodeName + '.jpg');
				        that.qrcodeVisible = false
				    } catch (e) {//如果为其他浏览器，使用base64转码下载
				        var url = canvas.toDataURL('image/jpeg');
				        $("#download").attr('href', url).get(0).click();
				        that.qrcodeVisible = false
				    }
				    return false;
//				}
			},
			Deldata(index,row){
				var that = this
				that.$confirm('确认删除该条信息?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	that.listloading = true
					that.delform = Object.assign({}, row);
					let u = '/questionnaires/'+that.delform._id
					that.axios.delete(u,{
						params: {
				     		token: that.token,
				    	}
					}).then(res => {
						if(res.status == "204"){
							that.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
				          	that.Quickfind()
//				          	this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
						}else{
							that.$message.error('对不起，请求失败。')
							that.listloading = false
						}
					}).catch(err => {
						that.$message.error(err.response.data.message)
						that.listloading = false
					})
			    }).catch(()=>{
			    	that.$message({
			        	type: 'info',
			            message: '已取消'
			        });
			        that.listloading = false
			    })
			},
//			exportExcel () {
//			 /* generate workbook object from table */
//			var wb = XLSX.utils.table_to_book(document.querySelector('#OnlyBox'))
//			 /* get binary string as output */
//			var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
//			console.log("XLSX",XLSX)
//			console.log("wb",wb)
////			try {
////			  FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
////			 } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
////			 return wbout
//			},
			SelectChange(value){
				this.Thelastest.addr = this.AddrSelect
			},
			rest(){
				this.AddrSelect = []
				this.BirthTime = ""
				this.HurtTime = ""
				this.CustName = ""
				this.CustPhone = ""
				this.CustHeight1 = ""
				this.CustHeight2 = ""
				this.CustWeight1 = ""
				this.CustWeight2 = ""
				this.CustWaitLine1 = ""
				this.CustWaitLine2 = ""
				this.BetweenData.birth = ""
				this.BetweenData.injurytime = ""
				this.Thelastest.name = ""
				this.Thelastest.phone = ""
				this.BetweenData.height = ""
				this.BetweenData.weight = ""
				this.BetweenData.waist = ""
				this.Thelastest.addr = ""
				this.Quickfind()
			},
			Find(){
				if(this.BirthTime){this.BetweenData.birth = [this.BirthTime[0]/1000,this.BirthTime[1]/1000]}
				if(this.HurtTime){this.BetweenData.injurytime = [this.HurtTime[0]/1000,this.HurtTime[1]/1000]}
				if(this.CustName){this.Thelastest.name = "~" + this.CustName}
				if(this.CustPhone){this.Thelastest.phone = "~" + this.CustPhone}
				if(this.CustHeight1 && this.CustHeight2){this.BetweenData.height = [this.CustHeight1,this.CustHeight2]}
				if(this.CustWeight1 && this.CustWeight2){this.BetweenData.weight = [this.CustWeight1,this.CustWeight2]}
				if(this.CustWaitLine1 && this.CustWaitLine2){this.BetweenData.waist = [this.CustWaitLine1,this.CustWaitLine2]}
				this.Quickfind()
			},
			Filterfind(filters){
				var that = this
				for(var item in filters){
					if(filters[item]){
						that.lastAll[item] = filters[item]
					}
				}
				var AQ1 =[],AQ3=[],AQ4=[],BQ9=[]
				for(var k in that.lastAll){
					if(k.indexOf("AQ1") != -1){
						AQ1 = AQ1.concat(that.lastAll[k])
						that.Thelastest.AQ1 = AQ1
					}
					else if(k.indexOf("AQ3") != -1){
						AQ3 = AQ3.concat(that.lastAll[k])
						that.Thelastest.AQ3 = AQ3
					}
					else if(k.indexOf("AQ4") != -1){
						AQ4 = AQ4.concat(that.lastAll[k])
						that.Thelastest.AQ4 = AQ4
					}
					else if(k.indexOf("BQ9") != -1){
						BQ9 = BQ9.concat(that.lastAll[k])
						that.Thelastest.BQ9 = BQ9
					}else{
						that.Thelastest[k] = that.lastAll[k]
					}
				}
//				console.log(that.Thelastest2)
				this.Quickfind()
			},
			Quickfind(){
				var that = this
//				that.listloading = true
				if(that.BetweenData){
					for(var k in that.BetweenData){
						that.LastBetween[k] = that.BetweenData[k]
						for(var m=0;m<that.BetweenData[k].length;m++){
							that.LastBetween[k][m] = parseInt(that.BetweenData[k][m])
						}
					}
				}
				
				if(that.Thelastest){
					for(var i in that.Thelastest){
						that.Thelastest2[i] = that.Thelastest[i]
						for(var j=0;j<that.Thelastest[i].length;j++){
							if(i == "edu" || i == "name" || i == "phone" || i == "addr"){
								that.Thelastest2[i] = that.Thelastest[i]
							}else{
								that.Thelastest2[i][j] = parseInt(that.Thelastest[i][j])
							}
						}
					}
				}
				
				this.Screenall = {}
				for(var i in that.Thelastest2){
					if(that.Thelastest2[i] && that.Thelastest2[i].length > 0){
						this.Screenall[i] = that.Thelastest2[i]
						}
				}
				
				this.Betweenall = {}
				for(var i in that.LastBetween){
					if(that.LastBetween[i] && that.LastBetween[i].length > 0){
						this.Betweenall[i] = that.LastBetween[i]
						}
				}
//				console.log("Screenall",this.Screenall)
//				console.log("Betweenall",this.Betweenall)
				var ever = [{"AND":this.Screenall},{"BETWEEN":this.Betweenall}]
				var ever2 = JSON.stringify(ever)
				
				if(this.Screenall || this.Betweenall){
					this.GetList({page:this.Curpage,perPage:this.Pagesize,token:this.token,q:ever2,sort:"-_id"})
				}else{
					this.GetList({page:this.Curpage,perPage:this.Pagesize,token:this.token,sort:"-_id"})
				}
			},
			Refresh(){
				
			},
			handleSizeChange(val){
				this.Pagesize = val
				this.Quickfind()
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Quickfind()
			},
			GetList2(somany){
				var that = this
				this.listloading = true
				GetUsersDetail(somany).then(res => {
					console.log(res)
					that.pageCount = res.data.meta.pageCount
					that.List = res.data.items
					for(var i=0;i<this.List.length;i++){
						this.List[i].sNumber = i+1
					}
					console.log("thst.List",that.List)
					var baselist = res.data.items
					for(var i=0;i<baselist.length;i++){
						that.AQ101 = []
						that.AQ102 = []
						that.AQ103 = []
						that.AQ104 = []
						for(var j=0;j<baselist[i].AQ1.length;j++){
//							console.log(baselist[i].AQ1[j])
							var it = baselist[i].AQ1[j]
							if(it > 16 && it < 23){
								that.AQ101.push(it)
							}else if(it > 32 && it < 44){
								that.AQ102.push(it)
							}else if(it > 48 && it < 53){
								that.AQ103.push(it)
							}else if(it > 64 && it < 69){
								that.AQ104.push(it)
							}
						}
						baselist[i].AQ101 = that.AQ101
						baselist[i].AQ102 = that.AQ102
						baselist[i].AQ103 = that.AQ103
						baselist[i].AQ104 = that.AQ104
					}
					
					console.log("thst.baselist",baselist)
					that.Curpage = res.data.meta.currentPage
					that.Pagesize = res.data.meta.perPage
					that.total = res.data.meta.totalCount
					that.listloading = false
				}).catch(err => {
					console.log(err)
					this.$message.error(err.response.data.message)
					this.List = []
					this.listloading = false
				})
			},
			GetList(somany){
				var that = this
				this.listloading = true
				GetUsersDetail(somany).then(res => {
					console.log(res)
					that.pageCount = res.data.meta.pageCount
					that.List = res.data.items
					for(var i=0;i<this.List.length;i++){
						this.List[i].sNumber = i+1
					}
					console.log("thst.List",that.List)
					var baselist = res.data.items
					for(var i=0;i<baselist.length;i++){
						that.AQ101 = []
						that.AQ102 = []
						that.AQ103 = []
						that.AQ104 = []
						for(var j=0;j<baselist[i].AQ1.length;j++){
//							console.log(baselist[i].AQ1[j])
							var it = baselist[i].AQ1[j]
							if(it > 16 && it < 23){
								that.AQ101.push(it)
							}else if(it > 32 && it < 44){
								that.AQ102.push(it)
							}else if(it > 48 && it < 53){
								that.AQ103.push(it)
							}else if(it > 64 && it < 69){
								that.AQ104.push(it)
							}
						}
						baselist[i].AQ101 = that.AQ101
						baselist[i].AQ102 = that.AQ102
						baselist[i].AQ103 = that.AQ103
						baselist[i].AQ104 = that.AQ104
					}
					
					console.log("thst.baselist",baselist)
					that.Curpage = res.data.meta.currentPage
					that.Pagesize = res.data.meta.perPage
					that.total = res.data.meta.totalCount
					that.listloading = false
				}).catch(err => {
					console.log(err)
					this.$message.error(err.response.data.message)
					this.List = []
					this.listloading = false
				})
			},
			uniquelize(){
				var tmp = {},
                ret = [];
	            for (var i = 0, j = this.length; i < j; i++) {
	                if (!tmp[this[i]]) {
	                    tmp[this[i]] = 1;
	                    ret.push(this[i]);
	                }
	            }
	            return ret;
			}
		},
		created(){
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList({page:this.Curpage,perPage:this.Pagesize,token:this.token,sort:"-_id"})
		},
		mounted(){
//			/* eslint-disable */
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
.el-select{
		width: 100px;
	}
.Wjbox {
	width: 60%;
	margin: 0 auto;
	margin-top: 20px;
}
.Wjbox h3 {
	text-align: center;
}
.Wjbox p {
	font-size: 18px;
	margin-bottom: 0;
	font-weight: 500;
	color: #999;
	background: #EDEDED;
}
.Wjbox h6 {
	font-weight: normal;
	margin: 0;
	margin-top: 5px;
	/*padding-left: 25px;*/
	font-size: 16px;
}
#OnlyBox {
	text-align: center;
}
#OnlyBox .cell {
	text-align: center;
}
</style>
<style type="text/css" scoped="scoped">
	.el-checkbox {
		margin-left: 0;
		margin-right: 30px;
	}
	.uptool {
		margin-bottom: 0;
		overflow: hidden;
	}
	.downsearch {
		cursor: pointer;
	}
	.noheight {
		height: 0;
	}
	.autoheight {
		height: auto;
	}
	.oldinput .el-input__inner {
		color: black;
	}
</style>


// WEBPACK FOOTER //
// CustomerInformation.vue?027f5096